import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import AssetImage from '../../Common/AssetImage';
import HandOffLink from '../../../utils/urls/HandOffLink';
import typography from '../../../styling/mixins/typography';
import {
  DESKTOP_START_QUERY,
  DESKTOP_MEDIUM_START_QUERY,
} from '../../../styling/mixins/responsive';

const CardsWrapper = styled.div`
  align-items: center;
  background-color: ${({ backgroundColor }) => backgroundColor};
  display: flex;
  height: 180px;
  justify-content: space-around;
  margin-bottom: 8px;
  padding: 16px 8px;
  overflow: hidden;

  @media (min-width: 480px) {
    height: 200px;
  }

  @media (${DESKTOP_START_QUERY}) {
    height: 240px;
  }
`;

// Hide desktop card content if there's more than 2 cards...
const blockStyles = ({ singleCardMobile }) => css`
  flex-direction: column;
  flex-grow: 1;
  padding: 0px 8px 24px;
  text-align: center;
  width: 45%;
  ${
    singleCardMobile
      ? ``
      : `
      &:first-child {
        width: 100%;

        @media (${DESKTOP_START_QUERY}) {
          width: 25%;

          *:nth-child(n+3) {
            display: none;
          }
        }
      }
    `
  }

  @media (${DESKTOP_START_QUERY}) {
    width: 25%;
  }

  @media (${DESKTOP_MEDIUM_START_QUERY}) {
    padding: 0px 1rem 16;
  }
`;

function getShapeStyles({ shape }) {
  switch (shape) {
    case 'square':
      return css`
        max-width: 110px;

        @media (${DESKTOP_MEDIUM_START_QUERY}) {
          max-width: 150px;
        }
      `;
    case 'horizontal':
    case 'wide':
      return css`
        max-width: 130px;

        @media (${DESKTOP_MEDIUM_START_QUERY}) {
          max-width: 180px;
        }
      `;
    default:
      return '';
  }
}

const BlockImage = styled(AssetImage)`
  box-shadow: 1px 4px 8px rgba(0, 0, 0, 0.15);
  margin: 0 12px;
  max-height: 100%;
  max-width: 100px;

  @media (${DESKTOP_START_QUERY}) {
    max-width: 130px;
  }

  ${getShapeStyles} ${({ hideMobile }) =>
    hideMobile &&
    `
    display: none;
    @media (${DESKTOP_START_QUERY}) {
      display: unset;
    }
  `};
`;

const BlockText = styled.div`
  ${typography.linkStyles};
`;

class CategoryBlock extends Component {
  static propTypes = {
    name: PropTypes.string,
    url: PropTypes.string,
    cards: PropTypes.arrayOf(
      PropTypes.shape({
        shape: PropTypes.string,
        name: PropTypes.string,
        image: PropTypes.string,
      }),
    ),
    className: PropTypes.string,
    color: PropTypes.string,
    singleCardMobile: PropTypes.bool,
  };

  render() {
    const { name, url, cards, className, color, singleCardMobile } = this.props;

    const Block = styled(HandOffLink)`
      ${blockStyles};
    `;

    return (
      <Block
        className={className}
        href={url}
        singleCardMobile={singleCardMobile}
        identifier={name}
      >
        <CardsWrapper backgroundColor={color}>
          {cards.map((card, i) => (
            <BlockImage
              key={i}
              shape={card.shape}
              src={card.image}
              size={card.size}
              alt={card.name || card.title}
              hideMobile={singleCardMobile && i > 0}
            />
          ))}
        </CardsWrapper>
        <BlockText>{name}</BlockText>
      </Block>
    );
  }
}

export default CategoryBlock;
